exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/components/administra-img-mc/administra-img-mc.component.css
// module id = ../../../../../src/app/components/administra-img-mc/administra-img-mc.component.css
// module chunks = 1